import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'
import {ITraderMapCampaign} from './list'

export const getTraderMapCampaignDetail = async (id: string): Promise<ApiRes<ITraderMapCampaign>> => {
    return await apiGet(API_URL, `admin/trader/campaign/${id}`)
}
